import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percent',
  standalone: true
})
export class PercentPipe implements PipeTransform {
  transform(value: any, precision: number = 0): unknown {
    let input = parseFloat(value);

    if (isNaN(input)) {
      return value;
    }

    return (input * 100.0).toFixed(precision).replace('.', ',') + '%';
  }
}
